"use strict";

import "../css/common.scss";
import { drawer } from "./modules/drawer";
import { hashLink } from "./modules/hashLink";
import { modal } from "./modules/modal";
import { tabs } from "./modules/tabs";

(function(window) {
  window.addEventListener("DOMContentLoaded", () => {
    drawer();
    hashLink();
    modal(); // NOTE 本来なら、コンテンツグループ毎のjsでやるべきだった
    tabs(); // NOTE 本来なら、コンテンツグループ毎のjsでやるべきだった
  });
})(window);